import React from 'react';
import { useInView } from 'react-intersection-observer'
import './Nosotros.css';
import imagenNosotros from '../../assets/About/nosotros.png';
import imagenDistribucion from '../../assets/About/nosotros2.jpg';

const Nosotros = () => {
  const { ref: refHeader, inView: inViewHeader } = useInView({
    triggerOnce: false,
    threshold: 0.3,
  });

  const { ref: refNosotros, inView: inViewNosotros } = useInView({
    triggerOnce: false,
    threshold: 0.3,
  });

  const { ref: refDistribucion, inView: inViewDistribucion } = useInView({
    triggerOnce: false,
    threshold: 0.3,
  });

  return (
    <div className="nosotros-container">
      {/* Título Principal */}
      <div
        ref={refHeader}
        className={`header-title ${inViewHeader ? 'slide-in-center' : ''}`}
      >
        <h1>COBERTURA GLOBAL LOGISTIC MJ PERU S.A.C</h1>
      </div>

      {/* Sección Nosotros */}
      <div
        ref={refNosotros}
        className={`section nosotros ${inViewNosotros ? 'slide-in-right' : ''}`}
      >
        <div className="text-nosotros">
          <h2>Nosotros</h2>
          <p>
            <strong>COBERTURA GLOBAL LOGISTIC MJ PERU SAC</strong> con RUC <strong>20611853883</strong> especializada en VENTA AL POR MAYOR 
            DE ALIMENTOS, BEBIDAS Y TABACO... Fue creada y fundada el <strong>22/11/2023</strong>, registrada dentro de las 
            sociedades mercantiles y comerciales como una SOCIEDAD ANONIMA CERRADA es una empresa en Perú, 
            con sede principal en Lima y sucursal en Cajamarca, Opera en Comerciantes al por Mayor de Comestibles
            y Productos Relacionados sector, así poder brindar un servicio de primer nivel para la satisfacción 
            de nuestros clientes.
          </p>
        </div>
        <div className="image-content">
          <img src={imagenNosotros} alt="Nosotros" />
        </div>
      </div><br /><br /><br /><br /><br />

      {/* Sección Distribución y Transporte */}
      <div
        ref={refDistribucion}
        className={`section distribucion ${inViewDistribucion ? 'slide-in-left' : ''}`}
      >
        <div className="image-content">
          <img src={imagenDistribucion} alt="Distribución y Transporte" />
        </div>
        <div className="text-distribucion">
          <h2>Distribución y Transporte</h2>
          <p>
          <strong>DISTRIBUCIÓN Y TRANSPORTE COBERTURA GLOBAL LOGISTIC MJ PERU</strong>, posee modernos 
          vehículo de transporte de carga y equipada 
           con tecnología de última generación, cumpliendo con todas las exigencias referidas a las 
           Buenas Prácticas de Transporte y Distribución, para el desarrollo del servicio a nivel 
           de Cajamarca,
          </p>
        </div>
      </div><br /><br /><br /><br />
    </div>
  );
};

export default Nosotros;
